import { render } from "./AquaparkEvent.vue?vue&type=template&id=be6b6e36"
import script from "./AquaparkEvent.vue?vue&type=script&lang=js"
export * from "./AquaparkEvent.vue?vue&type=script&lang=js"

import "./AquaparkEvent.vue?vue&type=style&index=0&id=be6b6e36&lang=scss"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__